import React from 'react'

import { IconInfo } from 'src/components/ui'

import styles from './NoNotifications.module.scss'

const NoNotifications = () => {
  return (
    <div className={styles.wrapper}>
      <IconInfo className={styles.wrapper_icon} color='violet' name='notification' />

      <h1>Сповіщень немає</h1>
      <p className={styles.subtitle}>У вас поки що немає нових результатів чи повідомлень.</p>
    </div>
  )
}

export default NoNotifications
